import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { mapActions, mapGetters } from 'vuex';
import * as types from '@reserve/store/types'

import DatePicker from '@appbase/components/DatePicker/DatePicker.vue'


@Component({
    components: {
        DatePicker
    },

    computed: mapGetters({
        searchSet: types.CALENDAR_SEARCHSET
    }),

    methods: mapActions({
        searchSetUpdate: types.CALENDAR_SEARCHSET_UPDATE
    })
})
export default class SearchPanel  extends Vue {
    searchSetUpdate!: (payload: reserve.ReserveSearchSet) => void;

    searchSet!: reserve.ReserveSearchSet;

    searchStart: string = "";
    searchEnd: string = "";

    mReserverName: string = "";
    mTitle: string = "";
    mContent: string = "";

    created() {
        this.searchStart = this.searchSet.searchStart;
        this.searchEnd = this.searchSet.searchEnd;
        this.mReserverName = this.searchSet.reserverName;
        this.mTitle = this.searchSet.reserveTitle;
        this.mContent = this.searchSet.reserveContent;
    }

    onSearchClick() {
        var searchSet = <reserve.ReserveSearchSet> {
            searchStart: this.searchStart,
            searchEnd: this.searchEnd,
            reserverName: this.mReserverName.trim().length == 0 ? null : this.mReserverName,
            reserveTitle: this.mTitle.trim().length == 0 ? null : this.mTitle,
            reserveContent: this.mContent.trim().length == 0 ? null : this.mTitle
        }

        this.searchSetUpdate(searchSet);
        this.$emit('search', searchSet);
    }
}